import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ChatMessage from "./ChatMessage";
import TypingIndicator from "./TypingIndicator";

const ChatArea = ({ messages, isTyping, children }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  return (
    <div className="flex-1 overflow-y-auto p-6">
      {messages.map((msg) => (
        <ChatMessage key={msg.id} message={msg} />
      ))}
      {isTyping && <TypingIndicator />}
      {children}
      <div ref={messagesEndRef} />
    </div>
  );
};

ChatArea.propTypes = {
  messages: PropTypes.array.isRequired,
  isTyping: PropTypes.bool,
  children: PropTypes.node
};

export default ChatArea;
